import { useState } from 'react'
import { Button } from '../../shared/components/Button'
import { FormFieldset, FormInput } from '../../shared/components/Fieldset'
import { API_URL } from '../../constants'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const LoginPage = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    })

    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const navigate = useNavigate()
    const { t } = useTranslation()

    const handleChange = e => {
        const { name, value } = e.target
        setFormData(prev => ({ ...prev, [name]: value }))
    }

    const handleSubmit = async e => {
        e.preventDefault()
        setError('')
        setLoading(true)

        try {
            const res = await fetch(`${API_URL}/admin/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'en',
                },
                body: JSON.stringify(formData),
            })

            const data = await res.json()

            if (!res.ok) {
                throw new Error(data.message || 'Login failed')
            }

            localStorage.setItem('token', data.data.token)
            localStorage.setItem('adminData', JSON.stringify(data.data.admin))
            navigate('/admin/auth/dashboard')
        } catch (err) {
            setError(err.message)
        } finally {
            setLoading(false)
        }
    }
    return (
        <div className='flex items-center justify-center min-h-screen p-4 bg-gray-50'>
            <div className='w-full max-w-md p-8 bg-white shadow-lg rounded-xl'>
                <form className='items-center space-y-6' onSubmit={handleSubmit}>
                    <FormFieldset title={t('auth.adminLogin')}>
                        <FormInput
                            label={t('auth.email')}
                            name='email'
                            type='email'
                            value={formData.email}
                            onChange={handleChange}
                        />
                        <FormInput
                            label={t('auth.password')}
                            name='password'
                            type='password'
                            value={formData.password}
                            onChange={handleChange}
                        />
                    </FormFieldset>

                    {error && <p className='text-sm text-red-500'>{error}</p>}

                    <Button
                        size='large'
                        className='flex items-center justify-center w-full mt-8'
                        type='submit'
                        disabled={loading}
                    >
                        {loading ? t('auth.logging') : t('auth.login')}
                    </Button>
                </form>
            </div>
        </div>
    )
}

export default LoginPage
